var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading.body",
          value: _vm.loading,
          expression: "loading",
          modifiers: { body: true }
        }
      ]
    },
    [
      _c(
        "div",
        { staticClass: "c_page-title" },
        [
          _c("div", [_vm._v("商品欠货列表")]),
          _vm._v(" "),
          _c(
            "el-button",
            {
              staticClass: "icon-fresh",
              attrs: { size: "mini", icon: "el-icon-refresh" },
              on: {
                click: function($event) {
                  return _vm.fetchData(true)
                }
              }
            },
            [_vm._v("刷新")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        { staticClass: "filter" },
        [
          _c(
            "el-col",
            [
              _c(
                "div",
                {
                  staticStyle: {
                    background: "#f3f3f3",
                    height: "30px",
                    "line-height": "30px",
                    padding: "0 25px",
                    display: "flex",
                    "align-items": "center"
                  }
                },
                [
                  _c("div", [_vm._v("查询搜索")]),
                  _vm._v(" "),
                  _c(
                    "el-button",
                    {
                      staticStyle: { "margin-left": "auto" },
                      attrs: {
                        type: "text",
                        icon: _vm.filterFold
                          ? "el-icon-arrow-down"
                          : "el-icon-arrow-up"
                      },
                      on: { click: _vm.toggleFilter }
                    },
                    [
                      _vm._v(
                        "\n          " +
                          _vm._s(_vm.filterFold ? "展开筛选" : "收起筛选") +
                          "\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c("el-collapse-transition", [
                _c(
                  "div",
                  {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: !_vm.filterFold,
                        expression: "!filterFold"
                      }
                    ]
                  },
                  [
                    _c(
                      "div",
                      { staticStyle: { padding: "10px 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "输入搜索：" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商品货号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_no,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_no", $$v)
                                    },
                                    expression: "form.goods_no"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商品款号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_kh,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_kh", $$v)
                                    },
                                    expression: "form.goods_kh"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商品名称" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.goods_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "goods_name", $$v)
                                    },
                                    expression: "form.goods_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "市场" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.market_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "market_name", $$v)
                                    },
                                    expression: "form.market_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "商家" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.supply_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "supply_name", $$v)
                                    },
                                    expression: "form.supply_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      multiple: "",
                                      placeholder: "请选择商家城市"
                                    },
                                    model: {
                                      value: _vm.form.city,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "city", $$v)
                                      },
                                      expression: "form.city"
                                    }
                                  },
                                  _vm._l(_vm.citys, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "品牌" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.brand_name,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "brand_name", $$v)
                                    },
                                    expression: "form.brand_name"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "代采单号" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.woid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "woid", $$v)
                                    },
                                    expression: "form.woid"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "选择买手组" },
                                        model: {
                                          value: _vm.form.pg_id,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pg_id", $$v)
                                          },
                                          expression: "form.pg_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.optionPicker,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          placeholder: "选择代采组",
                                          multiple: "",
                                          filterable: ""
                                        },
                                        model: {
                                          value: _vm.form.pgid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "pgid", $$v)
                                          },
                                          expression: "form.pgid"
                                        }
                                      },
                                      _vm._l(
                                        _vm.resData.optionPurchase,
                                        function(item) {
                                          return _c("el-option", {
                                            key: item.key,
                                            attrs: {
                                              label: item.label,
                                              value: item.key
                                            }
                                          })
                                        }
                                      ),
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "选择来源" },
                                        model: {
                                          value: _vm.form.transfer_type,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "transfer_type",
                                              $$v
                                            )
                                          },
                                          expression: "form.transfer_type"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.optionTransferType,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "欠货类型" },
                                        model: {
                                          value: _vm.form.referer_type,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "referer_type",
                                              $$v
                                            )
                                          },
                                          expression: "form.referer_type"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.optionRefererType,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "交易类型" },
                                        model: {
                                          value: _vm.form.jy_type,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "jy_type", $$v)
                                          },
                                          expression: "form.jy_type"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.optionJyType,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          multiple: "",
                                          filterable: "",
                                          placeholder: "订单负责人"
                                        },
                                        model: {
                                          value: _vm.form.order_owner,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "order_owner",
                                              $$v
                                            )
                                          },
                                          expression: "form.order_owner"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.option_order_owner,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "是否已支付" },
                                        model: {
                                          value: _vm.form.order_paied,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "order_paied",
                                              $$v
                                            )
                                          },
                                          expression: "form.order_paied"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "0" }
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "已支付", value: "1" }
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "未支付", value: "2" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          multiple: "",
                                          placeholder: "次品组"
                                        },
                                        model: {
                                          value: _vm.form.dgid,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "dgid", $$v)
                                          },
                                          expression: "form.dgid"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.resData.dg_group, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          multiple: "",
                                          placeholder: "退换货负责人"
                                        },
                                        model: {
                                          value: _vm.form.dpc_id,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "dpc_id", $$v)
                                          },
                                          expression: "form.dpc_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(_vm.resData.option_dgm, function(
                                          item
                                        ) {
                                          return _c("el-option", {
                                            key: item.value,
                                            attrs: {
                                              label: item.label,
                                              value: item.value
                                            }
                                          })
                                        })
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          placeholder: "计划类型"
                                        },
                                        model: {
                                          value: _vm.form.ptype,
                                          callback: function($$v) {
                                            _vm.$set(_vm.form, "ptype", $$v)
                                          },
                                          expression: "form.ptype"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.option_ptype,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.key,
                                              attrs: {
                                                label: item.label,
                                                value: item.key
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "计划id" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.planid,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "planid", $$v)
                                    },
                                    expression: "form.planid"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: {
                                          filterable: "",
                                          multiple: "",
                                          placeholder: "售后退供员"
                                        },
                                        model: {
                                          value: _vm.form.refunder_id,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "refunder_id",
                                              $$v
                                            )
                                          },
                                          expression: "form.refunder_id"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _vm._l(
                                          _vm.resData.dgm_refunder,
                                          function(item) {
                                            return _c("el-option", {
                                              key: item.value,
                                              attrs: {
                                                label: item.label,
                                                value: item.value
                                              }
                                            })
                                          }
                                        )
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.resData
                              ? _c(
                                  "el-form-item",
                                  [
                                    _c(
                                      "el-select",
                                      {
                                        attrs: { placeholder: "代采开单方式" },
                                        model: {
                                          value: _vm.form.order_type,
                                          callback: function($$v) {
                                            _vm.$set(
                                              _vm.form,
                                              "order_type",
                                              $$v
                                            )
                                          },
                                          expression: "form.order_type"
                                        }
                                      },
                                      [
                                        _c("el-option", {
                                          attrs: { label: "全部", value: "" }
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "实单", value: "1" }
                                        }),
                                        _vm._v(" "),
                                        _c("el-option", {
                                          attrs: { label: "排单", value: "2" }
                                        })
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: {
                                      placeholder: "预处理方式",
                                      multiple: ""
                                    },
                                    model: {
                                      value: _vm.form.pre_label,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "pre_label", $$v)
                                      },
                                      expression: "form.pre_label"
                                    }
                                  },
                                  _vm._l(_vm.pre_label, function(item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value
                                      }
                                    })
                                  }),
                                  1
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "代采订单付款状态" },
                                    model: {
                                      value: _vm.form.wcg_pag_status,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.form,
                                          "wcg_pag_status",
                                          $$v
                                        )
                                      },
                                      expression: "form.wcg_pag_status"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: "0", label: "全部" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.wcg_pag_status, function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-select",
                                  {
                                    attrs: { placeholder: "代采欠货标签" },
                                    model: {
                                      value: _vm.form.owe_label,
                                      callback: function($$v) {
                                        _vm.$set(_vm.form, "owe_label", $$v)
                                      },
                                      expression: "form.owe_label"
                                    }
                                  },
                                  [
                                    _c("el-option", {
                                      attrs: { value: "0", label: "全部" }
                                    }),
                                    _vm._v(" "),
                                    _vm._l(_vm.oweLabelOptions, function(item) {
                                      return _c("el-option", {
                                        key: item.value,
                                        attrs: {
                                          label: item.label,
                                          value: item.value
                                        }
                                      })
                                    })
                                  ],
                                  2
                                )
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "扫码出库人" },
                                  nativeOn: {
                                    keyup: function($event) {
                                      if (
                                        !$event.type.indexOf("key") &&
                                        _vm._k(
                                          $event.keyCode,
                                          "enter",
                                          13,
                                          $event.key,
                                          "Enter"
                                        )
                                      ) {
                                        return null
                                      }
                                      return _vm.search.apply(null, arguments)
                                    }
                                  },
                                  model: {
                                    value: _vm.form.stock_out_create_admin_str,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "stock_out_create_admin_str",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "form.stock_out_create_admin_str"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticStyle: { padding: "0 25px" } },
                      [
                        _c(
                          "el-form",
                          {
                            staticClass: "demo-form-inline",
                            attrs: { inline: true, model: _vm.form }
                          },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "操作时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "time", $$v)
                                    },
                                    expression: "form.time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "代采单时间：" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.wcg_order_time,
                                    callback: function($$v) {
                                      _vm.$set(_vm.form, "wcg_order_time", $$v)
                                    },
                                    expression: "form.wcg_order_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              { attrs: { label: "退换货生成时间" } },
                              [
                                _c("el-date-picker", {
                                  attrs: {
                                    type: "daterange",
                                    "value-format": "yyyy-MM-dd",
                                    "range-separator": "至",
                                    "start-placeholder": "开始日期",
                                    "end-placeholder": "结束日期"
                                  },
                                  model: {
                                    value: _vm.form.stock_out_create_time,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.form,
                                        "stock_out_create_time",
                                        $$v
                                      )
                                    },
                                    expression: "form.stock_out_create_time"
                                  }
                                })
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "el-form-item",
                              [
                                _c(
                                  "el-button",
                                  {
                                    attrs: { type: "primary" },
                                    on: { click: _vm.search }
                                  },
                                  [_vm._v("查询")]
                                )
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ]
                )
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _vm.resData
            ? _c(
                "el-col",
                { staticClass: "data-statics", attrs: { span: 24 } },
                [
                  _vm._v("\n      数据汇总    \n      "),
                  _c("span", [
                    _vm._v(
                      "欠货数量：" +
                        _vm._s(_vm.resData.total.num) +
                        "件        "
                    )
                  ]),
                  _vm._v(" "),
                  _c("span", [
                    _vm._v(
                      "欠货金额：¥" +
                        _vm._s(_vm.resData.total.amount) +
                        "        "
                    )
                  ])
                ]
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-row",
        [
          _c("el-col", { staticStyle: { border: "1px solid #ddd" } }, [
            _c(
              "div",
              {
                staticStyle: {
                  background: "#f3f3f3",
                  height: "50px",
                  "line-height": "30px",
                  padding: "0 25px",
                  display: "flex",
                  "align-items": "center"
                }
              },
              [
                _c(
                  "div",
                  { staticStyle: { display: "inline-block", width: "10%" } },
                  [_vm._v("数据列表：")]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      display: "inline-block",
                      "text-align": "right",
                      width: "90%"
                    }
                  },
                  [
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "primary" },
                        on: { click: _vm.restoreOwedGoods }
                      },
                      [_vm._v("\n            退换货恢复欠货\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "danger" },
                        on: { click: _vm.handleDelivery }
                      },
                      [_vm._v("\n            在途转欠货\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "info" },
                        on: { click: _vm.endWcg }
                      },
                      [_vm._v("\n            结束代采\n          ")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "info" },
                        on: { click: _vm.getReasonSelection }
                      },
                      [_vm._v("\n            转坏账")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        attrs: { size: "mini", type: "success" },
                        on: { click: _vm.output }
                      },
                      [_vm._v("\n            导出")]
                    )
                  ],
                  1
                )
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "margin-bottom": "0" } },
              [
                _vm.resData
                  ? _c(
                      "el-table",
                      {
                        directives: [
                          {
                            name: "loading",
                            rawName: "v-loading",
                            value: _vm.tableLoading,
                            expression: "tableLoading"
                          }
                        ],
                        ref: "multipleTable",
                        staticStyle: { width: "100%" },
                        attrs: {
                          height: "600",
                          data: _vm.resData.list,
                          "tooltip-effect": "dark"
                        },
                        on: { "selection-change": _vm.handleSelectionChange }
                      },
                      [
                        _c("el-table-column", {
                          attrs: { align: "center", type: "selection" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "goods_img",
                            label: "商品图片"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          width: "40px",
                                          height: "40px",
                                          overflow: "hidden",
                                          cursor: "pointer",
                                          margin: "auto"
                                        }
                                      },
                                      [
                                        _c("img", {
                                          staticStyle: {
                                            width: "100%",
                                            height: "100%"
                                          },
                                          attrs: { src: scope.row.goods_img[0] }
                                        })
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2891840473
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "planid",
                            label: "计划编号"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "wcg_plan_ptype",
                            label: "计划类型"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            align: "center",
                            prop: "goods_name",
                            label: "商品名称",
                            width: "180"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c(
                                      "el-tooltip",
                                      {
                                        staticClass: "item",
                                        attrs: {
                                          effect: "dark",
                                          content: row.goods_name,
                                          placement: "top-start"
                                        }
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "ellipsis-2" },
                                          [_vm._v(_vm._s(row.goods_name))]
                                        )
                                      ]
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2174310633
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_no",
                            label: "商品货号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_kh",
                            label: "商品款号",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "co_val",
                            label: "颜色",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "si_val",
                            label: "尺寸",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "market_name",
                            label: "市场",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_name",
                            label: "商家",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "supply_city",
                            label: "城市",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "brand_name",
                            label: "品牌",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pg_name",
                            label: "买手组",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pgname",
                            label: "代采组",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "order_owner_name",
                            filterable: "",
                            label: "订单负责人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dg_group_name",
                            filterable: "",
                            label: "次品组",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "dgm_name",
                            filterable: "",
                            label: "退换货负责人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "refunder",
                            filterable: "",
                            label: "售后退供员",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "woid",
                            label: "代采订单",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "order_create_time",
                            label: "提交时间",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "180"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "price",
                            label: "代采价",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "paid_price",
                            label: "实付价",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "jy_type",
                            label: "交易类型",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wcg_owe_record_transfer_type",
                            label: "来源",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "reject_referer_type",
                            label: "欠货类型",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(ref) {
                                  var row = ref.row
                                  return [
                                    _c("div", [
                                      _vm._v(_vm._s(row.reject_referer_type))
                                    ]),
                                    _vm._v(" "),
                                    row.is_transit_formal
                                      ? _c(
                                          "div",
                                          { staticStyle: { color: "#006cff" } },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(row.is_transit_formal) +
                                                "\n              "
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1090857283
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "admin_name",
                            label: "操作人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "create_time",
                            label: "操作时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pay_time",
                            label: "支付时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "wcg_order_type",
                            label: "代采开单方式",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "status_time_formal",
                            label: "代采欠货标签更新",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "goods_return_day",
                            label: "承诺回货时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pre_label",
                            label: "预处理标签",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "apply_img",
                            label: "预处理凭证",
                            "show-overflow-tooltip": "",
                            align: "center"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "div",
                                      {
                                        directives: [
                                          {
                                            name: "viewer",
                                            rawName: "v-viewer"
                                          }
                                        ],
                                        staticStyle: {
                                          width: "40px",
                                          height: "40px",
                                          overflow: "hidden",
                                          cursor: "pointer",
                                          margin: "auto"
                                        }
                                      },
                                      _vm._l(scope.row.pre_images, function(
                                        item,
                                        key
                                      ) {
                                        return _c("img", {
                                          key: key,
                                          staticStyle: {
                                            "max-width": "100%",
                                            "max-height": "100%"
                                          },
                                          attrs: { src: item }
                                        })
                                      }),
                                      0
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1202823784
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pre_remark",
                            label: "预处理备注",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pre_admin_name",
                            label: "预处理人",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "pre_create_time",
                            label: "预处理时间",
                            "show-overflow-tooltip": "",
                            align: "center"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "stock_out_create_admin_str",
                            label: "扫码出库人",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "90"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "stock_out_create_time",
                            label: "退换货生成时间",
                            "show-overflow-tooltip": "",
                            align: "center",
                            width: "150"
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            ),
            _vm._v(" "),
            _vm.resData
              ? _c(
                  "div",
                  { staticStyle: { "text-align": "right", padding: "25px" } },
                  [
                    _c("el-pagination", {
                      attrs: {
                        "current-page": _vm.curPage,
                        background: "",
                        layout: "total, prev, pager, next, jumper, sizes",
                        total: _vm.resData.count,
                        "page-size": _vm.form.psize,
                        "page-sizes": [10, 50, 100]
                      },
                      on: {
                        "update:currentPage": function($event) {
                          _vm.curPage = $event
                        },
                        "update:current-page": function($event) {
                          _vm.curPage = $event
                        },
                        "update:pageSize": function($event) {
                          return _vm.$set(_vm.form, "psize", $event)
                        },
                        "update:page-size": function($event) {
                          return _vm.$set(_vm.form, "psize", $event)
                        },
                        "current-change": _vm.handleCurrentChange,
                        "size-change": _vm.pageSizeChange
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.debt.show_dialog,
            "close-on-click-modal": false,
            title: "申请转坏账原因"
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.debt, "show_dialog", $event)
            }
          }
        },
        [
          _c("el-cascader", {
            attrs: {
              placeholder: "请选择原因",
              options: _vm.reason_selection,
              props: { expandTrigger: "hover" },
              filterable: ""
            },
            model: {
              value: _vm.debt.reason,
              callback: function($$v) {
                _vm.$set(_vm.debt, "reason", $$v)
              },
              expression: "debt.reason"
            }
          }),
          _vm._v(" "),
          _c("br"),
          _vm._v(" "),
          _c("div", { staticStyle: { "margin-top": "20px" } }, [
            _vm._v("填写备注")
          ]),
          _vm._v(" "),
          _c("el-input", {
            attrs: { type: "textarea", placeholder: "请填写备注" },
            model: {
              value: _vm.debt.remark,
              callback: function($$v) {
                _vm.$set(_vm.debt, "remark", $$v)
              },
              expression: "debt.remark"
            }
          }),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.debt.show_dialog = false
                    }
                  }
                },
                [_vm._v("取 消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { type: "primary" }, on: { click: _vm.toDebtBroken } },
                [_vm._v("确 定")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.isDeliveryModal,
            "close-on-click-modal": false,
            title: "在途转欠货",
            width: "680px",
            "before-close": _vm.closeDeliveryDialog
          },
          on: {
            "update:visible": function($event) {
              _vm.isDeliveryModal = $event
            }
          }
        },
        [
          _c(
            "el-form",
            {
              ref: "deliveryRef",
              attrs: {
                model: _vm.deliveryForm,
                "label-position": "top",
                "label-width": "100px"
              }
            },
            [
              _c("div", [
                _vm._v("商家：" + _vm._s(_vm.deliveryForm.supply_name))
              ]),
              _vm._v(" "),
              _c("div", { staticStyle: { "margin-top": "4px" } }, [
                _vm._v(
                  "\n        共选择" +
                    _vm._s(_vm.deliveryForm.models) +
                    "款，" +
                    _vm._s(_vm.deliveryForm.packages) +
                    "件，确定向商家申请转回代采欠货？\n      "
                )
              ]),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "商家沟通凭证（最多3张）：", prop: "imgs" } },
                [
                  _c("YsUpload", {
                    attrs: { max: 3 },
                    model: {
                      value: _vm.deliveryForm.images,
                      callback: function($$v) {
                        _vm.$set(_vm.deliveryForm, "images", $$v)
                      },
                      expression: "deliveryForm.images"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-form-item",
                { attrs: { label: "", prop: "reason" } },
                [
                  _c("YsInput", {
                    attrs: {
                      placeholder: "备注，非必填，最多20字",
                      maxlength: 20,
                      type: "textarea",
                      "show-word-limit": "",
                      autosize: { minRows: 3, maxRows: 5 }
                    },
                    model: {
                      value: _vm.deliveryForm.remark,
                      callback: function($$v) {
                        _vm.$set(_vm.deliveryForm, "remark", $$v)
                      },
                      expression: "deliveryForm.remark"
                    }
                  })
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            {
              staticStyle: { "text-align": "center" },
              attrs: { slot: "footer" },
              slot: "footer"
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function($event) {
                      _vm.isDeliveryModal = false
                    }
                  }
                },
                [_vm._v("取消")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: { type: "primary" },
                  on: { click: _vm.handleDeliveryConfirm }
                },
                [_vm._v("\n        确定\n      ")]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3f38748e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f38748e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/PurchaseGoodsToBeReturned.vue
// module id = null
// module chunks = 